import Logo from '@/components/Logo';
import Divider from '@/components/Divider';
import { Button, Link } from '@mui/material';
import NextLink from 'next/link';

const Footer = () => {
    return (
        <div className="mainFooter">
            <div className="mainFooterTop">
                <Logo />
                <div className="mainFooterLinks">
                    <div className="mainFooterTextLinkGroup">
                        <Link href="/privacy" component={NextLink}>
                            Privacy
                        </Link>
                    </div>
                    <div className="mainFooterTextLinkGroup">
                        <Link href="/terms" component={NextLink}>
                            Terms
                        </Link>
                    </div>
                    <div className="mainFooterCTALinkGroup">
                        <a href="mailto:beta@apexsignals.io">
                            <Button variant="outlined">Contact us</Button>
                        </a>
                    </div>
                </div>
            </div>
            <Divider />
            <div className="footerBottom">
            © Copyright {new Date().getFullYear()} Apex Signals Ltd
            </div>
        </div>
    );
};

export default Footer;